export const PlaylistConstant = {
    GETALL_REQUEST: 'PLAYLIST_GETALL_REQUEST',
    GETALL_SUCCESS: 'PLAYLIST_GETALL_SUCCESS',
    GETALL_FAILURE: 'PLAYLIST_GETALL_FAILURE',
};



// WEBPACK FOOTER //
// ./src/_constants/playlist.constants.js